<nz-modal
  [(nzVisible)]="isVisible"
  nzCentered
  [nzFooter]="null"
  nzClosable="false"
  nzWidth="520px"
>
  <ng-container *nzModalContent>
    <div class="flex flex-col items-center">
      <!-- Header -->
      <div class="relative w-full flex justify-center mb-3">
        <div class="flex justify-center items-center">
          <img src="https://storage.googleapis.com/komerce/core/icon-popup-success.png" alt="check" class="w-20 h-20">
        </div>
        <button class="absolute top-0 right-0 bg-transparent border-none text-lg text-gray-400 cursor-pointer p-1 flex items-center justify-center hover:text-gray-700" (click)="closeModal()">
          <span nz-icon nzType="close" nzTheme="outline"></span>
        </button>
      </div>

      <h2 class="text-xl font-bold text-center m-0 mb-4 text-gray-900">Download APK Android</h2>

      <!-- APK Info Card -->
      <div class="w-full flex items-center justify-between py-3 px-4 border border-gray-200 rounded-lg mb-3">
        <div class="flex items-center gap-3">
          <div class="flex items-center justify-center">
            <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/mobile.svg" alt="apk" class="w-10 h-10">
          </div>
          <div class="flex flex-col">
            <span class="font-medium text-sm text-gray-900">QRISLY Assistant.apk</span>
            <span class="text-xs text-gray-400">Version 2.0.0 - 8.3 MB</span>
          </div>
        </div>
        <button nz-button nzType="primary" class="text-white! border-none! rounded-full! px-6! h-[34px] font-semibold text-[13px]" (click)="downloadAPK()">Download</button>
      </div>

      <!-- Information Banner -->
      <div class="w-full bg-[#FFECE9] rounded-md py-3 px-4 mb-5 flex flex-col gap-0.5">
        <span class="font-medium text-[13px] text-gray-900">Information!</span>
        <span class="text-xs">Google Play Protect may block the installation. This is normal and safe to use.</span>
      </div>

      <!-- How To Install -->
      <h3 class="w-full text-[15px] font-semibold text-gray-900 m-0 mb-3 text-left">How To Install</h3>

      <!-- Step 1: Pause Play Protect -->
      <div class="w-full flex gap-4 p-4 border border-gray-200 rounded-lg mb-2.5  items-center">
        <div class="shrink-0 pt-0.5">
          <span class="w-7 h-7 rounded-full bg-[#DFF3FF] text-sm flex items-center justify-center">1</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-gray-900 mb-1.5">Pause Play Protect</span>
          <ol class="m-0 pl-0 text-[13px] leading-5">
            <li>1. Open Google Play Store</li>
            <li>2. Tap Profile → Play Protect → Settings</li>
            <li>3. Turn <strong>OFF</strong> "Scan apps with Play Protect"</li>
            <li>4. Download and Install APK</li>
            <li>5. Please reactivate after install</li>
          </ol>
        </div>
      </div>

      <!-- Step 2: Allow Unknown Service -->
      <div class="w-full flex gap-4 p-4 border border-gray-200 rounded-lg mb-2.5  items-center">
        <div class="shrink-0 pt-0.5">
          <span class="w-7 h-7 rounded-full bg-[#DFF3FF] text-sm flex items-center justify-center">2</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-gray-900 mb-1.5">Allow Unknown Service</span>
          <ol class="m-0 pl-0 text-[13px] leading-5">
            <li>1. Open Settings (on your phone) → Security</li>
            <li>2. Enable "Unknown sources" or "Install unknown apps"</li>
            <li>3. <strong>Download and Install APK</strong></li>
          </ol>
        </div>
      </div>

      <!-- Step 3: Override Warning -->
      <div class="w-full flex gap-4 p-4 border border-gray-200 rounded-lg mb-2.5  items-center">
        <div class="shrink-0 pt-0.5">
          <span class="w-7 h-7 rounded-full bg-[#DFF3FF] text-sm flex items-center justify-center">3</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-gray-900 mb-1.5">Override Warning</span>
          <ol class="m-0 pl-0 text-[13px] leading-5">
            <li>1. Download APK</li>
            <li>2. If appear warning, tap "More Details"</li>
            <li>3. Tap "Install anyway"</li>
          </ol>
        </div>
      </div>

      <!-- Application Feature -->
      <h3 class="w-full text-[15px] font-semibold text-gray-900 mt-10 mb-3 text-left">Application Feature</h3>

      <div class="w-full flex flex-col gap-3.5">
        <div class="flex items-center gap-3">
          <div class="shrink-0 w-8 h-8 flex items-center justify-center">
            <img src="https://storage.googleapis.com/komerce/assets/icons/archive-tick-green.svg" alt="feature" class="w-6 h-6">
          </div>
          <div class="flex flex-col">
            <span class="font-medium text-[13px] text-gray-900">Auto-detect Payment</span>
            <span class="text-xs">Automatic detection of payments from QRIS merchants</span>
          </div>
        </div>

        <div class="flex items-center gap-3">
          <div class="shrink-0 w-8 h-8 flex items-center justify-center">
            <img src="https://storage.googleapis.com/komerce/assets/icons/archive-tick-green.svg" alt="feature" class="w-6 h-6">
          </div>
          <div class="flex flex-col">
            <span class="font-medium text-[13px] text-gray-900">Real-time Notifications</span>
            <span class="text-xs">Webhook notification directly to the server</span>
          </div>
        </div>

        <div class="flex items-center gap-3">
          <div class="shrink-0 w-8 h-8 flex items-center justify-center">
            <img src="https://storage.googleapis.com/komerce/assets/icons/archive-tick-green.svg" alt="feature" class="w-6 h-6">
          </div>
          <div class="flex flex-col">
            <span class="font-medium text-[13px] text-gray-900">Secure & Low Battery</span>
            <span class="text-xs">HMAC signature verification with minimal battery consumption</span>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="w-full flex justify-center mt-10">
        <a class="text-[#E31A1A] text-sm cursor-pointer no-underline hover:underline" (click)="closeModal()">I've already downloaded the app</a>
      </div>
    </div>
  </ng-container>
</nz-modal>
